import { inject, Injectable } from '@angular/core';
import { Message, MessageService } from 'primeng/api';
import { AppResource } from 'src/app/app.resource';
export type ToastSeverity = 'success' | 'info' | 'warn' | 'error';

@Injectable({ providedIn: 'root' })
export class VyvToastService {
  resource = inject(AppResource)['resource'];
  private messageService = inject(MessageService);

  constructor() {}

  show(severity: ToastSeverity, message: string, hasTitle: boolean = false, titleCustom: string = ''): void {
    this.messageService.add(this.getToastConfig(severity, message, hasTitle, titleCustom));
  }

  getToastConfig(
    severity: ToastSeverity,
    message: string,
    hasTitle: boolean = false,
    titleCustom: string = '',
  ): Message {
    let conf: Message = {
      severity: severity,
      detail: message,
      life: 5000,
    };

    if (hasTitle) {
      conf.summary = titleCustom !== '' ? titleCustom : this.resource.generic[severity];
    }

    return conf;
  }
}
